const steps = [
  {
    number: '01',
    icon: 'ri-discuss-line',
    title: 'In-Depth Consultation',
    description: 'Our team meets with you to understand your vision, assess the scope, and provide transparent, accurate pricing with no surprises.',
  },
  {
    number: '02',
    icon: 'ri-tools-line',
    title: 'Preparation',
    description: 'The professionals are experts at all types of preparation, including scraping, sanding, caulking, and priming to ensure the paint goes on right.',
  },
  {
    number: '03',
    icon: 'ri-brush-3-line',
    title: 'Painting',
    description: 'We give great care while painting to avoid mistakes or accidents. Our painters always use drop cloths and painter\'s tape to protect your space.',
  },
  {
    number: '04',
    icon: 'ri-checkbox-circle-line',
    title: 'Clean Up',
    description: 'Our professionals also take care to clean up the area after the job is done. We\'ll make your place look great and leave it spotless.',
  },
];

export default function Process() {
  return (
    <section id="process" className="bg-charcoal-700 py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-sans text-gold text-xs tracking-[0.3em] uppercase">How It Works</span>
          <h2 className="font-serif text-warm-white text-4xl md:text-5xl mt-3">Our Process</h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className="group relative bg-charcoal-800 border border-gold/10 rounded-2xl p-8 hover:border-gold/40 hover:-translate-y-2 transition-all duration-300 cursor-default"
            >
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-[52px] left-[calc(100%+1px)] w-6 h-px bg-gold/30 z-10" />
              )}
              <div className="font-serif text-gold/25 text-6xl leading-none mb-4 group-hover:text-gold/40 transition-colors duration-300">
                {step.number}
              </div>
              <div className="w-10 h-10 flex items-center justify-center mb-4 bg-gold/10 rounded-full group-hover:bg-gold/20 transition-colors duration-300">
                <i className={`${step.icon} text-gold`} style={{ fontSize: '20px' }} />
              </div>
              <h3 className="font-serif text-warm-white text-lg mb-3">{step.title}</h3>
              <p className="font-sans text-warm-dim text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
